// Short-lived, media-only ticket used to sign <img>/attachment URLs so the
// full session JWT is never placed in a URL. Fetched from /api/media/ticket,
// cached in memory, and proactively refreshed before it expires.
import { useEffect, useState } from "react";
import { api } from "./api";

let ticket = "";
let expMs = 0;
let timer = null;
let inflight = null;
const listeners = new Set();

function emit() {
  listeners.forEach((fn) => fn(ticket));
}

export function getMediaTicket() {
  return ticket;
}

function schedule() {
  if (timer) clearTimeout(timer);
  const lead = 60 * 1000; // refresh ~1 min before expiry
  const delay = Math.max(30 * 1000, expMs - Date.now() - lead);
  timer = setTimeout(() => refreshMediaTicket(), delay);
}

export async function refreshMediaTicket() {
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const { data } = await api.get("/media/ticket");
      if (data?.token) {
        ticket = data.token;
        expMs = data.expires_at ? Date.parse(data.expires_at) : Date.now() + 15 * 60 * 1000;
        schedule();
        emit();
      }
    } catch {
      // 401 handled globally by the api interceptor
    } finally {
      inflight = null;
    }
    return ticket;
  })();
  return inflight;
}

export function stopMediaTicket() {
  if (timer) clearTimeout(timer);
  timer = null;
  ticket = "";
  expMs = 0;
  emit();
}

// Re-render image components when a fresh ticket lands.
export function useMediaTicket() {
  const [t, setT] = useState(ticket);
  useEffect(() => {
    const fn = (v) => setT(v);
    listeners.add(fn);
    if (!ticket) refreshMediaTicket();
    return () => listeners.delete(fn);
  }, []);
  return t;
}
